// extracted by mini-css-extract-plugin
export default {"movie-list":"MovieList_movie-list__+RMYr"};